import { ScrollTrigger } from 'gsap/ScrollTrigger';

/* ====================================
# トップページ採用セクションアニメーション
==================================== */
let recruitAnimationInitialized = false; // 重複実行防止フラグ

export const initTopRecruitAnimation = () => {
  if (recruitAnimationInitialized) return;
  recruitAnimationInitialized = true;

  const heroSection = document.querySelector('.p-top-recruit__hero');
  const heroImage = document.querySelector('.p-top-recruit__hero-image');
  const rightsText = document.querySelector('.p-top-recruit__hero-rights');

  if (!heroSection || !heroImage || !rightsText) return;

  // シンプルなScrollTrigger設定
  ScrollTrigger.create({
    trigger: heroSection,
    start: 'top 75%',
    end: 'bottom bottom',
    once: true,
    // markers: true,
    onEnter: () => {
      heroImage.classList.add('is-animated');
      setTimeout(() => {
        rightsText.classList.add('is-highlighted');
      }, 800);
    }
  });
};